/* SectionMgr.js */

"use strict";
const EditorSection = require("@gluenetworks/editor_section").EditorSectionComponent;

class SectionMgr extends EditorSection {
    constructor(di, logger, registeredDetails, userFeedback, solutionManager) {
        super(di, logger, registeredDetails);
        this._log = logger;
        this._di.registry.register(`EditorSection.EditorSectionMgr`, this);

        this._solutionManager = solutionManager;
        this._solutionManager.on("activeSolutionChanged", (this._solutionChanged = this._solutionChanged.bind(this)));

        this._userFeedback = userFeedback;

        //load it the first time through
        this._loadSolution();
    }
    _solutionChanged(/*newSolutionName,oldSolutionName*/) {
        this._loadSolution();
    }
    _loadSolution() {
        if (this._solutionManager.activeSolution && this._solutionManager.activeSolution.section === "GameCenter") {
            this.setLmrbNamespaces(this._solutionManager.activeSolution.lmrbNamespaces);
            this.setEditorNamespaces(this._solutionManager.activeSolution.editorNamespaces);
        } else {
            this.setEditorNamespaces([]);
            this._log.warn({
                ErrorCode: "NoSolutionSpecified",
                ErrorMsg: "A solution must be provided in the url."
            });
        }
    }
    shutdown() {
        this._solutionManager.removeListener("activeSolutionChanged", this._solutionChanged);
        this._di.registry.unregister(`EditorSection.EditorSection`);
        return super.shutdown().then(() => {
            this._userFeedback = undefined;
        });
    }
}
module.exports = SectionMgr;
module.exports.$inject = ["$teve.di", "$teve.logger", "$teve.registeredDetails", "$teve.ui.userFeedback", "$teve.solutionsManager"];
